const _allMensagens = [
	{
		val: 'QUAL O HORÁRIO DE ATENDIMENTO?',
		text: 'Qual o Horário de Atendimento?',
		departamento: '1, 2, 3, 4, 5, 6, 7, 8, 9',
		mensagens: [
			`Os profissionais ficam disponíveis para atendimento no *0800 773 2930 - FIQUE OK* de segunda a sexta, dias úteis, das 8 às 22h. Fora deste horário atendemos casos emergenciais.`
		]
	},
	{
		val: 'QUANDO INFORMA A DEMANDA/ É TERAPIA?',
		text: 'Quando Informa a Demanda/ É Terapia?',
		departamento: '1, 2, 3, 4, 5, 6, 7, 8, 9',
		mensagens: [
			`Qual o melhor período para falarmos?`
		]
	},
	{
		val: 'CONSIGO FALAR AGORA/ QUALQUER HORÁRIO',
		text: 'Consigo Falar Agora/ Qualquer Horário',
		departamento: '1, 2, 3, 4, 5, 6, 7, 8, 9',
		mensagens: [
			`Entraremos em contato em breve. Fique atento! Em caso de emergência ligue para *0800 773 2930 - FIQUE OK*`
		]
	},
	{
		val: 'QUANDO INFORMA O PERÍODO PARA CONTATO',
		text: 'Quando Informa o Período para Contato',
		departamento: '1, 2, 3, 4, 5, 6, 7, 8, 9',
		mensagens: [
			`Entraremos em contato no período de preferência, até no máximo 24 horas úteis. Fique atento! Em caso de emergência, ligue para *0800 773 2930 – FIQUE OK*`
		]
	},
	{
		val: 'COMO FUNCIONA O PROGRAMA?',
		text: 'Como Funciona o Programa?',
		departamento: '1, 2, 3, 4, 5, 6, 7, 8, 9',
		mensagens: [
			`O Programa de Apoio *FIQUE OK* é um benefício oferecido pela empresa aos funcionários e dependentes.\n\nO atendimento é realizado por uma equipe de psicólogos, assistentes sociais, nutricionistas, advogados, fisioterapeutas, personal trainer, enfermagem e pet consultor.\n\nÉ um serviço de apoio e orientação, realizado por telefone ou e-mail. Todos os atendimentos são sigilosos e gratuitos. *FIQUE OK - 0800 773 2930*`
		]
	},
	{
		val: 'MATRÍCULA INCORRETA/ NÃO LOCALIZAMOS NO SAP/ CONTATO GESTOR',
		text: 'Matrícula Incorreta/ Não Localizamos no SAP/ Contato Gestor',
		departamento: '1, 2, 3, 4, 5, 6, 7, 8, 9',
		mensagens: [
			`Neste primeiro contato precisamos ligar para você. Qual o melhor período para falarmos?`
		]
	},
	{
		val: 'SE NÃO RESPONDER EM 24H',
		text: 'Se não Responder em 24H',
		departamento: '1, 2, 3, 4, 5, 6, 7, 8, 9',
		mensagens: [
			`Você ainda precisa de ajuda do Programa de Apoio?`
		]
	},
	{
		val: 'DESLIGADOS',
		text: 'Desligados',
		departamento: '1, 2, 3, 4, 5, 6, 7, 8, 9',
		mensagens: [
			`Você pode utilizar o Programa de Apoio por 6 meses após a data de desligamento. Basta você ligar no *0800 773 2930 – FIQUE OK*`
		]
	},
	{
		val: 'COLABORADOR PCD',
		text: 'Colaborador PCD',
		departamento: '1, 2, 3, 4, 5, 6, 7, 8, 9',
		mensagens: [
			`Qual o tipo de deficiência?`
		]
	},
];

const getMensagens = () => _allMensagens;

module.exports = {
	getMensagens
}
